import React from 'react';
import ErrorPage from 'components/ErrorPage';

const UnAuthorized = () => <ErrorPage code='403' msg='无权限访问' />;

export default React.memo(UnAuthorized);
